import React, { useCallback, useMemo } from 'react';

import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { buildDefaultPrintSetting } from '../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../enums/document-type';
import { downloadDocument, printDocument } from '../../../../store/documents/documents.actions';
import { printCustomsFormsForOrders } from '../../../../store/printing/print.actions';
import PrintDocumentMenuItem from '../../../print-document-menu-item';

export const CustomsForm = ({ fulfillments, printSetting, salesOrders, userHasShippingRole, fulfillmentPlans }) => {
  const dispatch = useDispatch();
  const isDisabled = salesOrders.length === 0 || !userHasShippingRole;
  const fulfillmentIds = useMemo(() => fulfillments.map(({ fulfillmentId }) => fulfillmentId), [fulfillments]);
  const salesOrderIds = useMemo(() => salesOrders.map(({ salesOrderId }) => salesOrderId), [salesOrders]);
  const fulfillmentPlanIds = useMemo(() => fulfillmentPlans.map(({ fulfillmentPlanId }) => fulfillmentPlanId), [fulfillmentPlans]);

  const onClick = useCallback(() => {
    dispatch(printCustomsFormsForOrders(salesOrderIds));
  }, [dispatch, salesOrderIds]);
  const onPrint = useCallback(() => {
    dispatch(printDocument(DocumentType.CustomsForm, fulfillmentPlanIds, printSetting));
  }, [dispatch, fulfillmentPlanIds, printSetting]);
  const onDownload = useCallback(() => {
    dispatch(downloadDocument(DocumentType.CustomsForm, fulfillmentIds));
  }, [dispatch, fulfillmentIds]);
  const defaultPrintSetting = useMemo(
    () => buildDefaultPrintSetting(printSetting, onPrint, onDownload),
    [onDownload, onPrint, printSetting],
  );

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={isDisabled}
      name={DocumentType.CustomsForm.documentNameTranslation}
      onClick={onClick}
    />
  );
};

CustomsForm.propTypes = {
  fulfillments: PropTypes.arrayOf(
    PropTypes.shape({
      fulfillmentId: PropTypes.any.isRequired,
    }),
  ).isRequired,
  printSetting: PropTypes.any,
  salesOrders: PropTypes.array.isRequired,
  userHasShippingRole: PropTypes.bool.isRequired,
  fulfillmentPlans: PropTypes.arrayOf(
    PropTypes.shape({
      fulfillmentPlanId: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
